import DataExportFormatter from './DataExportFormatter';

export default class ExpenseFormatter extends DataExportFormatter {
	_getFormattedValueHook(column, expense) {
		switch (column) {
			case 'cost':
				return this._formatCurrency(expense.expenseCost);
			case 'item_id':
				return this._formatString(expense.expenseCategory.id);
			case 'item_name':
				return this._formatString(expense.expenseCategory.name);
			case 'item_type':
				return this._formatIntlMessage('common.expense');
			case 'markup':
				return this._formatPercentage(expense.expenseMarkup * 100);
			case 'profit':
				return this._formatCurrency(expense.expenseProfit);
			case 'revenue':
				return this._formatCurrency(expense.expenseRevenue);
			case 'margin':
				return this._formatPercentage(Math.round((expense.expenseProfit / expense.expenseRevenue) * 100));
			default:
				return null;
		}
	}
}
